var React = require('react');

function IconTrash (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M21.6,0H10.3C9.6,0,9,0.6,9,1.2v2.3H0v4.2h31.9V3.5h-9V1.2C22.9,0.6,22.3,0,21.6,0z M30,10.2H2V37\n\tc0,2,1.6,3.7,3.7,3.7h20.7c2,0,3.7-1.6,3.7-3.7V10.2H30z"}));
}

IconTrash.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 31.9 40.7","style":{"enableBackground":"new 0 0 31.9 40.7"},"xmlSpace":"preserve"};

module.exports = IconTrash;

IconTrash.default = IconTrash;
